import React from 'react';
import { colors, media } from '../../utils/styles';
import styled, { css } from 'styled-components';
import { FreebieIcon } from '../../icons';

export const Freebie = ({ alwaysShowAppFreebie, hideEbookFreebie }) => {
  // TODO: remove
  const isNoFreebieActive = true;
  return (
    <CardWrapper>
      {alwaysShowAppFreebie && (
        <Card>
          <Icon />
          <Header>
            <Badge>Free</Badge>
            <Heading>{`‎ReshapeMe: Workouts & Meals App Free Trial`}</Heading>
            <Price mobile>-$66.00</Price>
          </Header>
          <Image src="/img/freebie-app.png" alt={`Reshape Weight-loss App (iOS & Android)`} />
          <Price>-$66.00</Price>
          <Icon />
        </Card>
      )}
      {hideEbookFreebie ? null : !isNoFreebieActive ? (
        <Card>
          <Icon />
          <Header>
            <Badge>Free</Badge>
            <Heading>E-Book: Smoothies For Weight Loss</Heading>
            <Price mobile>-$19.90</Price>
          </Header>
          <Image src="/img/freebie.png" alt="E-Book: Smoothies For Weight Loss cover" />
          <Price>-$19.90</Price>
        </Card>
      ) : (
        <></>
      )}
    </CardWrapper>
  );
};

const Icon = styled(FreebieIcon)`
  top: -15px;
  left: -15px;
  position: absolute;
  ${media.phone} {
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 31px;
  }
`;

const Image = styled.img`
  margin-left: auto;
  height: 72px;
  width: auto;
  ${media.phone} {
    height: 82px;
  }
`;

const Price = styled.div`
  margin-left: 24px;
  font-size: 15px;
  line-height: 18px;
  text-align: right;
  text-decoration-line: line-through;
  color: ${colors.pink};
  ${p =>
    p.mobile &&
    css`
      display: none;
    `}
  ${media.phone} {
    display: none;
    ${p =>
      p.mobile &&
      css`
        display: block;
        margin-left: 0;
        margin-top: 16px;
        text-align: left;
      `};
  }
`;

const Header = styled.div`
  width: 180px;
`;

const Badge = styled.div`
  width: auto;
  padding: 0 8px;
  height: 19px;
  background: #dd3072;
  border-radius: 1px;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
`;

const Heading = styled.h5`
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  margin-top: 12px;
`;

const CardWrapper = styled.article`
  display: grid;
  grid-auto-flow: row;
  & > * {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    svg {
      display: none;
    }
    &:first-of-type {
      border-top: none;
      svg {
        display: block;
      }
    }
  }
`;

const Card = styled.article`
  background: #f9f9f9;
  padding: 16px 32px;
  display: flex;
  align-items: center;
  position: relative;
  ${media.phone} {
    text-align: left;
    padding: 15px 32px 20px 15px;
  }
`;
